<template>
  <VChip
    id="scheduled-consultation-type-chip"
    data-testid="scheduled-consultation-type-chip"
    density="compact"
    variant="outlined"
    :class="[
      'shrink-0 font-semibold border-gray-200 bg-gray-50 text-gray-700',
      { '!text-xs !px-2 !h-[22px]': size === 'small' }
    ]"
  >
    <span data-testid="consultation-type-label">
      {{ translateScheduledConsultationTypeDTO(consultationType, t) }}
    </span>
  </VChip>
</template>

<script setup lang="ts">
import { ScheduledConsultationTypeDTO } from '@/generated'
import { translateScheduledConsultationTypeDTO } from '@/util/translations'
import { useI18n } from 'vue-i18n'

const { consultationType, size = 'default' } = defineProps<{
  consultationType: ScheduledConsultationTypeDTO
  size?: 'small' | 'default'
}>()
const { t } = useI18n()
</script>
